import { Injectable } from '@angular/core';
import {shipmentCART, AdpCustomer, attributesMap, attributesPropertiesMap} from '../providers/data';
import {IMAGES_BASE_URL} from './config';
import { Storage } from '@ionic/storage';
import {DomSanitizer} from '@angular/platform-browser';
import { ToastController } from 'ionic-angular';
import {Constants} from './config';

@Injectable()
export class ShipmentcartManagerProvider {

  constructor(private storage:Storage,private sanitizer:DomSanitizer, public toastCtrl:ToastController) {
    console.log('Hello ShipmentcartManagerProvider Provider');
  }

  setCustomer(customer){

    if(shipmentCART.customer == null){

      shipmentCART.customer = customer;
    }else{
      this.clearCartProducts();
      shipmentCART.customer = customer;
    }
  }

  // setSalesPerson(user){
  //   shipmentCART.user = user;
  // }


  clearCart(){
    shipmentCART.items = [];
  }


  addToCartNew(product) {

      shipmentCART.items.push(product);
      this.persistOrderLocal();

  }
  addProductToCart(product) {

    var index= shipmentCART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {

      this.removeNew(index);
      this.addToCartNew(product);

    } else {
      this.addToCartNew(product);
    }
  }

  // update Cart
  updateCartNew(product) {

    if(Number(product.quantity) < Number(product.minOrder)){
      if (Number(product.minOrder) != 0) {
        if (Number(product.quantity) != 0) {
          product.quantity = Number(product.quantity);
        } else {
          product.quantity = 1;
        }
      } else {
        product.quantity = 1;
      }
    }


    var index= shipmentCART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
    } else {

      this.addToCartNew(product);
    }
    this.persistOrderLocal();
  }
  // Remove One
  removeOneNew(product) {
    var index= shipmentCART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
      if(shipmentCART.items[index].quantity > Number(product.minOrder)){
        shipmentCART.items[index].quantity--;
        this.persistOrderLocal();
      }else{
        shipmentCART.items[index].quantity = 0;
        this.removeNew(index);

      }

    }
  }

  // Remove All
  removeAll(product) {
    var index= shipmentCART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
      if(shipmentCART.items[index].quantity >= 1){
        shipmentCART.items[index].quantity = 0;
      }
    }
    this.persistOrderLocal();
  }


  // Remove Item
  removeNew(index: number): void {

    shipmentCART.items.splice(index, 1);
    this.persistOrderLocal();
  }

  deleteProductFromCart(product){
    this.removeAll(product);
    var index= shipmentCART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
      this.removeNew(index);
    }
  }

  genrateOrder(status){
    //alert(JSON.stringify(shipmentCART));
    let total = 0;
    let orderProducts = [];
    let expectedShipmentDate = shipmentCART.shipDate;
    console.log("cart in  manager service-------------",shipmentCART);
    for(let item of shipmentCART.items){

      if(this.discountCheck(item.discountPrice)){
        total =  total + (Number(item.discountPrice) * Number(item.quantity));
      }else{
        total =  total + (Number(item.price) * Number(item.quantity));
      }

      var orderDetailDTOs: any = {

        "productsDTO":item,
        "quantity": item.quantity,
        "expectedShipmentDate": expectedShipmentDate,
        "attributeSearch":item.attributeSearch
      };

      orderProducts.push(orderDetailDTOs);
    }

    if(shipmentCART.customer.locationsDTOs.length>0){
      for(let locationId in shipmentCART.customer.locationsDTO){
        shipmentCART.customer.locationsDTO[locationId].createdAt = "";
        shipmentCART.customer.locationsDTO[locationId].updatedAt = "";
      }
    }

    shipmentCART.customer.customerJson = "";

    let order = {
      "id":shipmentCART.orderId,
      "orderTitle": this.getOrderTitle(),
      "salesManId":shipmentCART.user.id,
      "orderMessage":shipmentCART.orderMessage,
      "expectedShipmentDate": shipmentCART.expectedShipmentDate,
      "totalAmount":""+total.toFixed(2),
      "totalTexAmount":"10",
      "orderStatus":status,
      "customerDTO":shipmentCART.customer,
      "orderDetailDTOs": orderProducts,
      "shippingServiceName":shipmentCART.shippingServiceName,
      "shippingServiceValue":shipmentCART.shippingServiceId
    };

    return order;

  }

  // orderShipment(status, cart, orderForShipment){
  //   let userDetail = this.getSalesPerson();
  //
  //   let total = 0;
  //   let orderProducts = [];
  //   let expectedShipmentDate = cart.shipDate;
  //   for(let item of cart.items){
  //
  //     if(this.discountCheck(item.discountPrice)){
  //       total =  total + (Number(item.discountPrice) * Number(item.quantity));
  //     }else{
  //       total =  total + (Number(item.price) * Number(item.quantity));
  //     }
  //
  //
  //     for(let location of item.productLocationsDTO){
  //       location.shippedQuantity = location.availableQuantity;
  //       let date = new Date(location.productInventoryReceivedDate);
  //       location.productInventoryReceivedDate = date;
  //     }
  //     var orderDetailDTOs: any = {
  //
  //       "productsDTO":item,
  //       "quantity": item.quantity,
  //       "expectedShipmentDate": expectedShipmentDate,
  //       "attributeSearch":item.attributeSearch
  //     };
  //
  //     orderProducts.push(orderDetailDTOs);
  //   }
  //
  //   cart.customer.customerJson = "";
  //
  //   let order = {
  //     "createdAt": orderForShipment.createdAt,
  //     "id":cart.orderId,
  //     "orderTitle": cart.orderTitle,
  //     "orderMessage":cart.orderMessage,
  //     "expectedShipmentDate": cart.expectedShipmentDate,
  //     "totalAmount":""+total.toFixed(2),
  //     "totalTexAmount":"10",
  //     "orderStatus":5,
  //     "customerDTO":cart.customer,
  //     "orderDetailDTOs": orderProducts,
  //     "shippingServiceName":cart.shippingServiceName,
  //     "shippingServiceValue":cart.shippingServiceId
  //   };
  //
  //   return order;
  //
  // }

  // receiveStock(status){
  //   //alert(JSON.stringify(shipmentCART));
  //   let total = 0;
  //   let orderProducts = [];
  //   let expectedShipmentDate = shipmentCART.shipDate;
  //   for(let item of shipmentCART.items){
  //
  //     if(this.discountCheck(item.discountPrice)){
  //       total =  total + (Number(item.discountPrice) * Number(item.quantity));
  //     }else{
  //       total =  total + (Number(item.price) * Number(item.quantity));
  //     }
  //
  //
  //     var orderDetailDTOs: any = {
  //
  //       "productsDTO":item,
  //       "quantity": item.quantity,
  //       "expectedShipmentDate": expectedShipmentDate,
  //       "attributeSearch":item.attributeSearch
  //     };
  //
  //     orderProducts.push(orderDetailDTOs);
  //   }
  //
  //   if(shipmentCART.customer.locationsDTOs.length>0){
  //     for(let locationId in shipmentCART.customer.locationsDTO){
  //       shipmentCART.customer.locationsDTO[locationId].createdAt = "";
  //       shipmentCART.customer.locationsDTO[locationId].updatedAt = "";
  //     }
  //   }
  //
  //   shipmentCART.customer.customerJson = "";
  //
  //   let order = {
  //     "id":shipmentCART.orderId,
  //     "barCode":shipmentCART.orderId,
  //     "orderTitle": this.getOrderTitle(),
  //     "salesManId":shipmentCART.user.id,
  //     "orderMessage":shipmentCART.orderMessage,
  //     "expectedShipmentDate": shipmentCART.expectedShipmentDate,
  //     "totalAmount":""+total.toFixed(2),
  //     "totalTexAmount":"10",
  //     "orderStatus":status,
  //     "customerDTO":shipmentCART.customer,
  //     "orderDetailDTOs": orderProducts,
  //     "shippingServiceName":shipmentCART.shippingServiceName,
  //     "shippingServiceValue":shipmentCART.shippingServiceId
  //   };
  //
  //   return order;
  //
  // }

  clearCartProducts(){
    for(let product of shipmentCART.items){
      this.removeAll(product);
    }
    shipmentCART.items = [];
  }

  getProductsCount(){
    return shipmentCART.items.length;
  }

  getSalesManId(){
    return shipmentCART.user.id;
  }
  getCustomerName(){
    if(shipmentCART.customer !=null){

      return shipmentCART.customer.name;
    }else{
      return null;
    }
  }

  getSalesPerson(){
    return shipmentCART.user;

  }

  getADPCustomerUUID(){
    if(shipmentCART.user && shipmentCART.user.adpCustomerInfo){
      return shipmentCART.user.adpCustomerInfo.uuid;
    }else{
      return "";
    }
  }

  setShipDate(shipDate){
    shipmentCART.expectedShipmentDate = shipDate ;
  }
  // getShipDate(){
  //   return shipmentCART.expectedShipmentDate;
  // }

  // setOdId(odId){
  //   shipmentCART.odId = odId;
  // }

  // getOdId(){
  //   return shipmentCART.odId;
  // }

  // setItems(productsList){
  //   shipmentCART.items = productsList;
  // }
  setOrderId(orderId){
    shipmentCART.orderId = orderId ;
  }
  setOrderMessage(orderMessage){
    shipmentCART.orderMessage = orderMessage;
  }
  // getOrderMessage(){
  //   return shipmentCART.orderMessage;
  // }

  // getExpectedSipDate(){
  //   return shipmentCART.expectedSipDate;
  // }

  getItems(){
    return shipmentCART.items;
  }


  getCustomerID(){
    if(shipmentCART.customer!=null){
      return shipmentCART.customer.id;
    }else{
      return false;
    }
  }


  // getSelectedCustomer(){
  //   return shipmentCART.customer;
  // }

  setOrderTitle(orderTitle){
    shipmentCART.orderTitle = orderTitle;
  }

  getOrderTitle(){
    return shipmentCART.orderTitle;
  }
  getOrderId(){
    return shipmentCART.orderId;
  }

  persistOrderLocal(){
    // TODO: Store the list of Cart against their user/sales persons
    let itemQuantityStatus = false;
    for(let product of shipmentCART.items){
      if(product.quantity > 0){
        itemQuantityStatus = true;
        break;
      }
    }

    if(Number(shipmentCART.items.length) > 0 && itemQuantityStatus){
      this.storage.set(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId(),shipmentCART);

    }else{
      this.unPersistOrderLocal();
    }
  }

  // saveOrder(order){
  //   this.storage.set("order", order)
  // }
  // removeOrder(){
  //   this.storage.remove("order");
  // }
  unPersistOrderLocal(){
    this.storage.remove(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId());

  }

  // getPersistedOrderLocal(){
  //
  //   return this.storage.get(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId());
  // }

  // setCartFull(cartTemp){
  //   shipmentCART.items = cartTemp.items;
  //   shipmentCART.orderId = cartTemp.orderId;
  //   shipmentCART.orderMessage = cartTemp.orderMessage;
  //   shipmentCART.customer = cartTemp.customer;
  //   shipmentCART.orderTitle = cartTemp.orderTitle;
  // }


  discountCheck(discountPrice){ // if discount price is > 0, return true
    if(Number(discountPrice) > 0){
      return true;
    }else{
      return false;
    }
  }

  getOrderStatus(){
    return shipmentCART.orderStatus;
  }

  setOrderStatus(status){
    shipmentCART.orderStatus = status;
  }


  // removeJunkFromCart(){
  //   for(let item of shipmentCART.items ){
  //     if(item.quantity == 0 || item.quantity == '0'){
  //       var index= shipmentCART.items.map(function(x) {return x.id; }).indexOf(item.id);
  //       if (index != -1) {
  //         if(shipmentCART.items[index].quantity >= 1){
  //           shipmentCART.items[index].quantity = 0;
  //         }
  //         shipmentCART.items.splice(index, 1);
  //       }
  //     }
  //   }
  // }


  makeImageURL(dimensions,item){
    // this.gVLogger.log("imagesDtos" + JSON.stringify( item.productsDTO));
    return  IMAGES_BASE_URL.imageBaseUrl + "/" + this.getADPCustomerUUID() +
      "/products/" +
      dimensions + "/"+
      item.productImagesDTO[0].name+
      "-" +
      dimensions +
      "." +
      item.productImagesDTO[0].extension;
  }


  // setShipingServiceName(name){
  //   shipmentCART.shippingServiceName = name;
  // }
  // getShippingServiceName(){
  //   return shipmentCART.shippingServiceName;
  // }

  // setShippingServiceId(id){
  //   shipmentCART.shippingServiceId = id;
  // }

  // getShippingServiceId(){
  //   return shipmentCART.shippingServiceId;
  // }


  // setAdpCustomerInfo(adpCustomerInfo){
  //   AdpCustomer.AdpCustomerInfo = adpCustomerInfo;
  // }

  getAdpCustomerInfo(){
    return AdpCustomer.AdpCustomerInfo;
  }


  // sanitizeUrl(url){
  //   return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  // }



  // addToAttributeMap(key,value){
  //   attributesMap[key+""] = ""+value;
  // }

  getAttributeValue(key){
    let res = attributesMap[key+""];
    if(res === undefined){
      return "-"
    }else{
      return res;
    }
  }


  // addAttributePropertiesMap(key,val){
  //   attributesPropertiesMap.set(key+"", val);
  // }

  // getAllAttributesPropertiesMap(){
  //   return attributesPropertiesMap;
  // }

  // replaceDoublePipe(str){
  //   return str.split("||").join(" ");
  // }

  // ConvertToCSV(objArray) {
  //   // alert(JSON.stringify(objArray));
  //   let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
  //   let str = '';
  //   let row = "";
  //   for (let index in objArray[0]) {
  //     //Now convert each value to string and comma-separated
  //     row += index + ',';
  //   }
  //   row = row.slice(0, -1);
  //   //append Label row with line break
  //   str += row + '\r\n';
  //   // str += row  ;
  //
  //   for (let i = 0; i < array.length; i++) {
  //     let line = '';
  //     for (let index in array[i]) {
  //       if (line != '') line += ',';
  //       line += array[i][index];
  //     }
  //     str += line + '\r\n';
  //     // str += line ;
  //   }
  //   return str;
  // }

  // ConvertToCSVDynamically(objArray) {
  //   // alert("array for csv conversion " + JSON.stringify(objArray));
  //   let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
  //   let str = '';
  //   let row = "";
  //   for (let index in objArray[0]) {
  //     //Now convert each value to string and comma-separated
  //     row += index.split("~")[0] + ',';
  //   }
  //   row = row.slice(0, -1);
  //   //append Label row with line break
  //   str += row + '\r\n';
  //   // str += row  ;
  //
  //   for (let i = 0; i < array.length; i++) {
  //     let line = '';
  //     for (let index in array[i]) {
  //       if (line != '') line += ',';
  //       line += array[i][index];
  //     }
  //     str += line + '\r\n';
  //     // str += line ;
  //   }
  //   return str;
  //
  // }
}



// WEBPACK FOOTER //
// ./src/providers/shipmentcart-manager.ts